<template>
	<!-- width="600px" 或者  width="60%"   -->
	<el-dialog
		:close-on-click-modal="false"
		title="指派"
		:show-close="true"
		:visible="true"
		:before-close="handleBeforeClose"
		width="400px"
	>
		<div class="dialog__container">
			<el-form
				inline
				ref="form"
				label-position="right"
				:model="form"
				label-width="70px"
				:rules="rules"
			>
				<el-form-item label="维保员：" prop="operatorUserId">
					<el-select
						size="mini"
						v-model="form.operatorUserId"
						filterable
						placeholder="请选择维保员"
						clearable
						reserve-keyword
						:remote="true"
						:remote-method="searchUserList"
						@visible-change="searchUserList('')"
					>
						<el-option
							v-for="item in userList"
							:key="item.userId"
							:label="item.nickname"
							:value="item.userId"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button
				class="plr28"
				size="mini"
				type="info"
				plain
				@click="handleCancel"
				>取消</el-button
			>
			<el-button class="plr28" type="primary" size="mini" @click="handleConfirm"
				>确定</el-button
			>
		</span>
	</el-dialog>
</template>

<script>
import { getUserSimpleList } from "@/api/MaintenancePlan";
import { saveAssign } from "@/api/AnnualInspection";
export default {
	data() {
		return {
			form: {
				operatorUserId: "",
			},
			userList: [],
			rules: {
				operatorUserId: [
					{
						required: true,
						message: "请选择维保员",
						trigger: "change",
					},
				],
			},
		};
	},
	props: ["designateRow"],
	methods: {
		async searchUserList(keyword) {
			const res = await getUserSimpleList({
				keyword: keyword,
				size: 100,
			});
			if (res.code === 200) {
				this.userList = res.data;
			}
		},

		handleBeforeClose(done) {
			this.$emit("cancel");
			done();
		},
		handleCancel() {
			this.$emit("cancel");
		},
		async handleConfirm() {
			this.$refs["form"].validate(async (valid) => {
				if (valid) {
					const params = { ...this.form };
					console.log(this.designateRow);
					params.orderId = this.designateRow.orderId;
					params.orderType = this.designateRow.orderType;
					const res = await saveAssign(params);

					if (res.code === 200) {
						this.$message.success("指派成功");
						this.$emit("confirm");
					}
				}
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/AnnualInspection/components/Designate.vue